import React from 'react'
import phot from "../Assets/pic.jpg"
import phot1 from "../Assets/pic1.jpg"


export default function LandingPage() {
  return (
    <>
      <div className="catageroy">
      <div className="heading">
        <h1>Abeer</h1>
        <h4>View More &#8594;</h4>
        </div>
        <div className="productCards">
            <div className="cards">
                <div className="CardImg">
                    <img src={phot} alt="" />
                </div>
                <div className="TextCard">
                    <p className='Name'>Abeer</p>
                    <p className='title'>Abeer - Aloevera,</p>
                    <p className='price'>₹99</p>
                </div>   
            </div>

            <div className="cards">
                <div className="CardImg">
                    <img src={phot1} alt="" />
                </div>
                <div className="TextCard">
                    <p className='Name'>Abeer</p>
                    <p className='title'>Abeer - Aloevera,</p>
                    <p className='price'>₹99</p>
                </div>   
            </div>

            <div className="cards">
                <div className="CardImg">
                    <img src={phot} alt="" />
                </div>
                <div className="TextCard">
                    <p className='Name'>Abeer</p>
                    <p className='title'>Abeer - Aloevera,</p>
                    <p className='price'>₹99</p>
                </div>   
            </div>

            <div className="cards">
                <div className="CardImg">
                    <img src={phot1} alt="" />
                </div>
                <div className="TextCard">
                    <p className='Name'>Abeer</p>
                    <p className='title'>Abeer - Aloevera,</p>
                    <p className='price'>₹99</p>
                </div>   
            </div>  
        </div>
      </div>

      <hr/>

      <div className="catageroy">
        <div className="heading">
        <h1>Delara</h1>
        <h4>View More &#8594;</h4>
        </div>
        <div className="productCards">
            <div className="cards">
                <div className="CardImg">
                    <img src={phot1} alt="" />
                </div>
                <div className="TextCard">
                    <p className='Name'>Abeer</p>
                    <p className='title'>Abeer - Aloevera,</p>
                    <p className='price'>₹99</p>
                </div>   
            </div>

            <div className="cards">
                <div className="CardImg">
                    <img src={phot} alt="" />
                </div>
                <div className="TextCard">
                    <p className='Name'>Abeer</p>
                    <p className='title'>Abeer - Aloevera,</p>
                    <p className='price'>₹99</p>
                </div>   
            </div>

            <div className="cards">
                <div className="CardImg">
                    <img src={phot1} alt="" />
                </div>
                <div className="TextCard">
                    <p className='Name'>Abeer</p>
                    <p className='title'>Abeer - Aloevera,</p>
                    <p className='price'>₹99</p>
                </div>   
            </div>

            <div className="cards">
                <div className="CardImg">
                    <img src={phot} alt="" />
                </div>
                <div className="TextCard">
                    <p className='Name'>Abeer</p>
                    <p className='title'>Abeer - Aloevera,</p>
                    <p className='price'>₹99</p>
                </div>   
            </div>  
        </div>
      </div>

      <hr/>

      <div className="catageroy">
        <div className="heading">
        <h1>Mritkala11</h1>
        <h4>View More &#8594;</h4>
        </div>
        <div className="productCards">
            <div className="cards">
                <div className="CardImg">
                    <img src={phot1} alt="" />
                </div>
                <div className="TextCard">
                    <p className='Name'>Abeer</p>
                    <p className='title'>Abeer - Aloevera,</p>
                    <p className='price'>₹99</p>
                </div>   
            </div>

            <div className="cards">
                <div className="CardImg">
                    <img src={phot} alt="" />
                </div>
                <div className="TextCard">
                    <p className='Name'>Abeer</p>
                    <p className='title'>Abeer - Aloevera,</p>
                    <p className='price'>₹99</p>
                </div>   
            </div>

            <div className="cards">
                <div className="CardImg">
                    <img src={phot1} alt="" />
                </div>
                <div className="TextCard">
                    <p className='Name'>Abeer</p>
                    <p className='title'>Abeer - Aloevera,</p>
                    <p className='price'>₹99</p>
                </div>   
            </div>

            <div className="cards">
                <div className="CardImg">
                    <img src={phot} alt="" />
                </div>
                <div className="TextCard">
                    <p className='Name'>Abeer</p>
                    <p className='title'>Abeer - Aloevera,</p>
                    <p className='price'>₹99</p>
                </div>   
            </div>  
        </div>
      </div>

      <div className="catageroy">
        <div className="heading">
        <h1>Panah3</h1>
        <h4>View More &#8594;</h4>
        </div>
        <div className="productCards">
            <div className="cards">
                <div className="CardImg">
                    <img src={phot1} alt="" />
                </div>
                <div className="TextCard">
                    <p className='Name'>Abeer</p>
                    <p className='title'>Abeer - Aloevera,</p>
                    <p className='price'>₹99</p>
                </div>   
            </div>

            <div className="cards">
                <div className="CardImg">
                    <img src={phot} alt="" />
                </div>
                <div className="TextCard">
                    <p className='Name'>Abeer</p>
                    <p className='title'>Abeer - Aloevera,</p>
                    <p className='price'>₹99</p>
                </div>   
            </div>

            <div className="cards">
                <div className="CardImg">
                    <img src={phot1} alt="" />
                </div>
                <div className="TextCard">
                    <p className='Name'>Abeer</p>
                    <p className='title'>Abeer - Aloevera,</p>
                    <p className='price'>₹99</p>
                </div>   
            </div>

            <div className="cards">
                <div className="CardImg">
                    <img src={phot} alt="" />
                </div>
                <div className="TextCard">
                    <p className='Name'>Abeer</p>
                    <p className='title'>Abeer - Aloevera,</p>
                    <p className='price'>₹99</p>
                </div>   
            </div>  
        </div>
      </div>

    </>
  )
}
